var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('object',{staticClass:"pdfViewer",attrs:{"data":_vm.url,"type":"application/pdf","width":"100%","height":"100%"}},[_c('embed',{attrs:{"src":_vm.url,"type":"application/pdf"}})])}
var staticRenderFns = []

export { render, staticRenderFns }